// extracted by mini-css-extract-plugin
export default {"inputBox":"App_inputBox__LzA0B","inputLabel":"App_inputLabel__FNQS5","lockScreen":"App_lockScreen__BqeOg"};